import { Component, ViewEncapsulation } from '@angular/core';
import { ImageItemModelService } from '@fi-app/template/image-item.model';
import { SimpleTextModelService } from '@fi-app/template/simple-text.model';
import { AdvancedTextModelService } from '@fi-app/template/advanced-text.model';
import { SiteMapItemModelService } from '@fi-app/template/site-map-item.model';

@Component({
    selector: 'fi-document-template-models-list',
    templateUrl: './document-template-models-list.component.html',
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./document-template-models-list.component.scss'],
    standalone: false,
})
export class FiDocumentTemplateModelsListComponent {
    modelsList: any[];

    constructor(
        imageItem: ImageItemModelService,
        simpleText: SimpleTextModelService,
        advancedTextItem: AdvancedTextModelService,
        siteMapItem: SiteMapItemModelService,
    ) {
        this.modelsList = [imageItem.create(), simpleText.create(), advancedTextItem.create(), siteMapItem.create()];
    }
}
